<template>
  <section class="huehome row">
    <div class="col-xs-12 col-md-6">
      <div class="box">
        <h1>Design, development and identity for your product.</h1>
        <p>Huehex is a digital agency specializing in mobile and web design and development, branding and animation.</p>
        <a href="#contact" class="button big-btn">Get in touch</a>
    </div>
    </div>
    <div class="col-xs-12 col-md-6 xs-hide sm-hide ">
     <div class="box"> <img src="@/assets/graphics.svg" alt="" /></div>
    </div>
  </section>
</template>

<script>
import ScrollMagic from 'scrollmagic';
// import $ from 'jquery';
export default {
  name: 'huehome',
  props: {
    msg: String
  },
  methods: {
    ScrollMagic
  },
  mounted() {
    
  },
}
</script>

<style scoped lang="scss">

  img{
    width: 100%;
  }
  h1{
    font-size: 50px;
    font-weight: 600;
    font-style: normal;
    line-height: 1.4;
  }
  p{
    font-size: 30px;
    font-weight: 600;
    font-style: normal;
    line-height: 1.37;
  }
  .button{
    margin-top:50px;
  }
</style>
